import { useEffect, useState } from "react"

// QUERIES
import { KURSISTER, GET_KURSISTER_BY_HOLD } from '../../../../queries/kursister.gql'
import { GET_KURSIST_HOLD } from '../../../../queries/hold.gql'
import { CREATE_JC_STATUS, UPDATE_JC_STATUS, DELETE_JC_STATUS } from '../../../../queries/catalogs/jc_statuser.gql'
import { JOBCOACH_COUNT, UPDATE_JOBCOACHS } from '../../../../queries/jobcoach.gql'
import { ALL_CATALOGS } from '../../../../queries/catalogs/allCatalogs.gql'

// HOOKS
import { useCatalog } from "../../../../hooks/useCatalog"

// COMPONENTS
import { AdminInterfaceTemplate } from "../AdminInterfaceTemplate/AdminInterfaceTemplate"
import CheckboxInput from "../../../Inputs/CheckboxInput/CheckboxInput"
import Input from "../../../Inputs/Input"

let lastData = [] 
let changeTimeStamp = new Date().valueOf();
const primaryKey = "Jc_Status_id"

export default function AdminInterfaceJobcoachStatuser() {
    const catalogs = useCatalog()
    const content = catalogs.jc_statuser

    const [newContent, setNewContent] = useState(content)
    const [searchString, setSearchString] = useState("")
    const [sort, setSort] = useState({field: "", dir: false})
    const [selected, setSelected] = useState(null)
    const [newObj, setNewObj] = useState(null)
    const [scrollToBottom, setScrollToBottom] = useState(false)
    const [customLoading, setCustomLoading] = useState(false)

    useEffect(() => {
        const filtered = AdminInterfaceTemplate.functions
        .localSearch(searchString, content, ["Jc_Status"])
        setNewContent(filtered)
    },[searchString])

    useEffect(() => {
        const sorted = AdminInterfaceTemplate.functions.localSort(newContent, sort)
        setNewContent(sorted)
    },[sort])

    useEffect(() => {
        if (customLoading)
            setCustomLoading(false)

        if (sort.field) {
            const sorted = AdminInterfaceTemplate.functions.localSort(content, sort)
            setNewContent(sorted)
        } else {
            setNewContent(content)
        }
        if (content.toString() != lastData.toString()) {
            changeTimeStamp = new Date().valueOf();
            lastData = content
        }
    },[content])

    const event = {
        search: (name, val) => {
            setSearchString(val)
        },
        sort: (field) => {
            setSort({field: field, dir: !sort.dir})
        },
        rowClick: (val, index) => {
            setNewObj(null)
            setSelected(val)
        },
        UpdateInput: (name, val) => {
            let updateObj = {...selected}
            updateObj[name] = val
            setSelected(updateObj)
        },
        createInput: (name, val) => {
            let updateObj = {...newObj}
            updateObj[name] = val
            setNewObj(updateObj)
        },
        new: () => {
            setSelected(null)
            setNewObj({
                Jc_Status: "",
                Aktivt: false
            })
        },
        createSuccess: (res) => {
            setSearchString("")
            setSelected(res)
            setScrollToBottom(true)
        },
        createStart: () => {
            setCustomLoading(true)
        },
        updateSuccess: (id) => {
            setSearchString("")
            setCustomLoading(false)
        },
        updateStart: () => {
            setCustomLoading(true)
        },
        deleteStart: () => {
            const htmlRow = document.querySelector(`[data-primary-key="${primaryKey}${selected[primaryKey]}"]`)
            htmlRow.classList.add("inactive_load")
            setCustomLoading(true)
        },
        deleteSuccess: () => {
            setSearchString("")
            setSelected(null)
            setNewObj(null)
        },
        moveStart: () => {
            setCustomLoading(true)
        },
        moveSuccess: () => {
            setSearchString("")
            setCustomLoading(false)
        }
    }

    return (
        <AdminInterfaceTemplate.component>
            <AdminInterfaceTemplate.content>
                <AdminInterfaceTemplate.table 
                    primaryKey={primaryKey}
                    changeTimeStamp={changeTimeStamp}
                    scrollToBottom={scrollToBottom}
                    setScrollToBottom={setScrollToBottom}
                    onNew={event.new}
                    searchFunction={event.search}
                    searchString={searchString}
                    content={newContent}
                    selected={selected}
                    rowClick={event.rowClick}
                    rowSelect={!selected ? null : {field: primaryKey, value: selected.Jc_Status_id}}
                    cells={[
                        {
                            size: 0,
                            title: "ID",
                            name: "Jc_Status_id",
                            sort: sort,
                            onClick: () => event.sort("Jc_Status_id")
                        },
                        {
                            size: 1,
                            title: "Status",
                            name: "Jc_Status",
                            sort: sort,
                            onClick: () => event.sort("Jc_Status")
                        },
                        {
                            size: 0,
                            title: "Aktiv",
                            name: "Aktivt",
                            sort: sort,
                            onClick: () => event.sort("Aktivt")
                        }
                    ]}
                />
                {/* `{{count}} Kursister er medlem af {{title}}, sletning er ikke opfordret! */}
                {selected ? 
                    <AdminInterfaceTemplate.update
                        variables={{
                            id: selected.Jc_Status_id,
                            input: {
                                Jc_Status: selected.Jc_Status,
                                Aktivt: selected.Aktivt
                            }
                        }}
                        updateQuery={UPDATE_JC_STATUS}
                        deleteQuery={DELETE_JC_STATUS}
                        refetchQueries={[ALL_CATALOGS]}
                        title={selected.Jc_Status}
                        id={selected.Jc_Status_id}
                        countQueryObj={{
                            query: JOBCOACH_COUNT,
                            variables: {
                                conditions: {
                                    Jc_Status_id: selected.Jc_Status_id
                                }
                            },
                            loading: "Checkker Jobcoach status...",
                            warning: "{{count}} kursister på hold med Jobcoach status {{title}}, Sletning er ikke opfordret!",
                            move: {
                                query: UPDATE_JOBCOACHS,
                                variables: {
                                    field: `Jc_Status_id`,
                                    from: selected.Jc_Status_id,
                                    title: selected.Jc_Status
                                },
                                refetchQueries: [KURSISTER, JOBCOACH_COUNT, ALL_CATALOGS, GET_KURSISTER_BY_HOLD, GET_KURSIST_HOLD],
                                onMoveStart: event.moveStart,
                                onMoveSuccess: event.moveSuccess,
                                text: "Skift Jobcoach status",
                                menuText: "Skift Jobcoach status for {{count}} kursist til hold?",
                                selectOptions: content.map(obj => ({value: obj.Jc_Status_id, title: obj.Jc_Status})),
                            },
                            delete: {
                                text: "Handlingen vil forsøge at nulstille jobcoach status værdierne for {{count}} kursister til hold, er du sikker på du ikke vil ændre jobcoach status værdierne først?"
                            }
                        }}
                        customLoading={customLoading}
                        onUpdateStart={event.updateStart}
                        onUpdateSuccess={event.updateSuccess}
                        onDeleteStart={event.deleteStart}
                        onDeleteSuccess={event.deleteSuccess}
                    >
                        <Input 
                            label="Status" 
                            name="Jc_Status" 
                            value={selected.Jc_Status} 
                            onInput={event.UpdateInput} 
                        />
                        <CheckboxInput 
                            label="Aktiv"
                            name="Aktivt"
                            value={selected.Aktivt}
                            onInput={event.UpdateInput} 
                        />
                    </AdminInterfaceTemplate.update>
                : newObj ?
                    <AdminInterfaceTemplate.create
                        variables={{
                            input: {...newObj}
                        }}
                        createQuery={CREATE_JC_STATUS}
                        refetchQuery={ALL_CATALOGS}
                        customLoading={customLoading}
                        onCreateSuccess={event.createSuccess}
                        onCreateStart={event.createStart}
                    >
                        <Input 
                            label="Status" 
                            name="Jc_Status" 
                            value={newObj.Jc_Status} 
                            onInput={event.createInput} 
                        />
                        <CheckboxInput 
                            label="Aktiv"
                            name="Aktivt"
                            value={newObj.Aktivt}
                            onInput={event.createInput} 
                        />
                    </AdminInterfaceTemplate.create>
                : <AdminInterfaceTemplate.empty />}

            </AdminInterfaceTemplate.content>
        </AdminInterfaceTemplate.component>
    )
}